import React from 'react';
import * as PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Badge } from '@material-ui/core';
import { selectListTotal } from '../../../lists/selectors';
import { useResourceList } from '../../../lists/hooks';
import { useBadgeRefresh } from './useBadgeRefresh';
import { CUSTOMER_RESOURCE } from '../../../api/resources';

// Mirrors the 'teamBK' branch of UnassignedCustomers.js's prepareSearch(): customers
// on team 'teamBK' that still need to be (re-)assigned to an employee.
const TeamleiterBadge = ({ children }) => {
    const listId = 'customer.teamleiterBadge';

    const { handlePage: handleCustomerUpdate } = useResourceList({
        listId,
        resource: CUSTOMER_RESOURCE,
        staticParams: {
            team: 'teamBK',
            employeeId: 'NULL',
            employeeFormerId: 'NOT_NULL',
            currentType: [
                'prospective',
                'contract',
                'nurse_deployed',
                'pause_short',
                'pause_long',
                'terminated_agency',
            ],
        },
        limit: 1,
        autoload: false,
        continuous: true,
        refresh: true,
    });

    const count = useSelector((state) => selectListTotal(state, listId));

    useBadgeRefresh(handleCustomerUpdate, CUSTOMER_RESOURCE);

    return (
        <Badge badgeContent={count} color="primary" key={`teamleiterbadge.${listId}`}>
            {children}
        </Badge>
    );
};

TeamleiterBadge.propTypes = {
    children: PropTypes.node.isRequired,
};

TeamleiterBadge.defaultProps = {};

export default TeamleiterBadge;
